import { render } from "./PopupManageCreateForm.vue?vue&type=template&id=4a9eb4a6&lang=true"
import script from "./PopupManageCreateForm.vue?vue&type=script&lang=js"
export * from "./PopupManageCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__